import { InjectionToken } from '@angular/core';

export const SelectedProductsToken = new InjectionToken<number[]>(
  'products_token'
);

export const ProductDependenciesToken = new InjectionToken<number[]>(
  'product_dependencies_token'
);
